import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';
import { addToWishlist, removeFromWishlist } from '../store/wishlistSlice';
import { addToCart } from '../store/cartSlice';
import { toast } from 'react-toastify';
import api from '../services/api';
import './Home.css';

/* ─── All 30 rich mock products ─── */
const ALL_PRODUCTS = [
  { id:1,  name:'Floral Print Maxi Dress',   brand:'ZARA',        price:2499, originalPrice:4999, imageUrl:'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=400&h=530&fit=crop&q=80', rating:4.3, reviewCount:128, sizes:['XS','S','M','L','XL'], colors:['Red','Blue','Green'], category:'women', isNew:true },
  { id:2,  name:'Slim Fit Oxford Shirt',      brand:'H&M',         price:1299, originalPrice:2599, imageUrl:'https://images.unsplash.com/photo-1594938298603-c8148c4b4415?w=400&h=530&fit=crop&q=80', rating:4.1, reviewCount:89,  sizes:['S','M','L','XL','XXL'], colors:['Blue','White','Pink'], category:'men' },
  { id:3,  name:'High Waist Denim Jeans',     brand:"LEVI'S",      price:3499, originalPrice:5999, imageUrl:'https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=530&fit=crop&q=80', rating:4.5, reviewCount:234, sizes:['28','30','32','34','36'], colors:['Blue','Black','Grey'], category:'men' },
  { id:4,  name:'Embroidered Kurti Set',      brand:'BIBA',        price:1899, originalPrice:3499, imageUrl:'https://images.unsplash.com/photo-1583482183071-9e174c8ba40b?w=400&h=530&fit=crop&q=80', rating:4.4, reviewCount:156, sizes:['XS','S','M','L','XL'], colors:['Pink','Blue','Yellow'], category:'women', isNew:true },
  { id:5,  name:'Air Max Running Shoes',      brand:'NIKE',        price:4999, originalPrice:8999, imageUrl:'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=530&fit=crop&q=80', rating:4.6, reviewCount:312, sizes:['6','7','8','9','10','11'], colors:['Black','White','Blue'], category:'men' },
  { id:6,  name:'Wrap Midi Dress',            brand:'ZARA',        price:3299, originalPrice:5999, imageUrl:'https://images.unsplash.com/photo-1525507119028-ed4c629a60a3?w=400&h=530&fit=crop&q=80', rating:4.6, reviewCount:201, sizes:['XS','S','M','L','XL'], colors:['Purple','Red','Forest Green'], category:'women', isNew:true },
  { id:7,  name:'Graphic Print Tee',          brand:'PUMA',        price:799,  originalPrice:1599, imageUrl:'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=530&fit=crop&q=80', rating:4.2, reviewCount:98,  sizes:['S','M','L','XL'], colors:['White','Black','Grey'], category:'men' },
  { id:8,  name:'Silk Blend Saree',           brand:'CRAFTSVILLA', price:5499, originalPrice:9999, imageUrl:'https://images.unsplash.com/photo-1605518215734-90a5aa1a7fa5?w=400&h=530&fit=crop&q=80', rating:4.7, reviewCount:445, sizes:['Free Size'], colors:['Red','Gold','Purple'], category:'women' },
  { id:9,  name:'Leather Tote Handbag',       brand:'CAPRESE',     price:2999, originalPrice:5999, imageUrl:'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=400&h=530&fit=crop&q=80', rating:4.3, reviewCount:178, sizes:['Free Size'], colors:['Brown','Black','Tan'], category:'women' },
  { id:10, name:'Kids Cartoon Tee',           brand:'H&M',         price:599,  originalPrice:1199, imageUrl:'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=400&h=530&fit=crop&q=80', rating:4.4, reviewCount:67,  sizes:['2-3Y','4-5Y','6-7Y','8-9Y'], colors:['White','Pink','Blue'], category:'kids', isNew:true },
  { id:11, name:'Slim Fit Formal Blazer',     brand:'VAN HEUSEN',  price:3999, originalPrice:7999, imageUrl:'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400&h=530&fit=crop&q=80', rating:4.5, reviewCount:89,  sizes:['S','M','L','XL'], colors:['Navy','Charcoal','Black'], category:'men' },
  { id:12, name:'Strappy Block Heels',        brand:'STEVE MADDEN',price:2799, originalPrice:5599, imageUrl:'https://images.unsplash.com/photo-1535043934128-cf0b28d52f95?w=400&h=530&fit=crop&q=80', rating:4.1, reviewCount:123, sizes:['UK4','UK5','UK6','UK7','UK8'], colors:['Nude','Black','Brown'], category:'women', isNew:true },
  { id:13, name:'Sports Fleece Hoodie',       brand:'ADIDAS',      price:2899, originalPrice:4999, imageUrl:'https://images.unsplash.com/photo-1556821840-3a63f15732ce?w=400&h=530&fit=crop&q=80', rating:4.4, reviewCount:145, sizes:['S','M','L','XL'], colors:['Grey','Black','Navy'], category:'men' },
  { id:14, name:'Ethnic Palazzo Set',         brand:'W',           price:2299, originalPrice:4499, imageUrl:'https://images.unsplash.com/photo-1567013127542-490d757e51fc?w=400&h=530&fit=crop&q=80', rating:4.3, reviewCount:134, sizes:['XS','S','M','L','XL'], colors:['Orange','Teal','Mustard'], category:'women', isNew:true },
  { id:15, name:'Trucker Denim Jacket',       brand:"LEVI'S",      price:4499, originalPrice:7999, imageUrl:'https://images.unsplash.com/photo-1544022613-e87ca75a784a?w=400&h=530&fit=crop&q=80', rating:4.5, reviewCount:167, sizes:['S','M','L','XL'], colors:['Light Blue','Dark Blue','Black'], category:'men' },
  { id:16, name:'Printed High Waist Leggings',brand:'NYKAA FASHION',price:699, originalPrice:1499, imageUrl:'https://images.unsplash.com/photo-1506629082955-511b1aa562c8?w=400&h=530&fit=crop&q=80', rating:4.1, reviewCount:89,  sizes:['XS','S','M','L','XL'], colors:['Black','Navy','Olive'], category:'women' },
  { id:17, name:'Kids Canvas Sneakers',       brand:'NIKE',        price:2499, originalPrice:3999, imageUrl:'https://images.unsplash.com/photo-1560769629-975ec94e6a86?w=400&h=530&fit=crop&q=80', rating:4.6, reviewCount:78,  sizes:['UK2','UK3','UK4','UK5','UK6'], colors:['White','Black','Pink'], category:'kids', isNew:true },
  { id:18, name:'Cocktail Bodycon Dress',     brand:'FOREVER 21',  price:1999, originalPrice:4999, imageUrl:'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=530&fit=crop&q=80', rating:4.0, reviewCount:112, sizes:['XS','S','M','L'], colors:['Black','Red','Royal Blue'], category:'women' },
  { id:19, name:'Relaxed Linen Trousers',     brand:'MANGO',       price:2199, originalPrice:3999, imageUrl:'https://images.unsplash.com/photo-1473966968600-fa801b869a1a?w=400&h=530&fit=crop&q=80', rating:4.2, reviewCount:56,  sizes:['28','30','32','34','36'], colors:['Beige','White','Navy'], category:'men' },
  { id:20, name:'Bohemian Wrap Skirt',        brand:'FOREVER 21',  price:999,  originalPrice:2499, imageUrl:'https://images.unsplash.com/photo-1583496661160-fb5218db1e1f?w=400&h=530&fit=crop&q=80', rating:4.0, reviewCount:67,  sizes:['XS','S','M','L'], colors:['Yellow','Multicolor'], category:'women' },
  { id:21, name:'Oversized Street Hoodie',    brand:'HYPHEN',      price:1799, originalPrice:3599, imageUrl:'https://images.unsplash.com/photo-1614251055880-ee96e4803393?w=400&h=530&fit=crop&q=80', rating:4.3, reviewCount:98,  sizes:['S','M','L','XL','XXL'], colors:['Cream','Black','Sage'], category:'men', isNew:true },
  { id:22, name:'Floral Midi Skirt',          brand:'AND',         price:1499, originalPrice:2999, imageUrl:'https://images.unsplash.com/photo-1594938374182-a57d94a29f77?w=400&h=530&fit=crop&q=80', rating:4.2, reviewCount:77,  sizes:['XS','S','M','L'], colors:['Floral','Pink','Blue'], category:'women', isNew:true },
  { id:23, name:'Premium Polo T-Shirt',       brand:'LACOSTE',     price:3499, originalPrice:5999, imageUrl:'https://images.unsplash.com/photo-1586363104862-3a5e2ab60d99?w=400&h=530&fit=crop&q=80', rating:4.5, reviewCount:203, sizes:['S','M','L','XL','XXL'], colors:['White','Navy','Red'], category:'men' },
  { id:24, name:'Embellished Clutch Bag',     brand:'ALDO',        price:1899, originalPrice:3499, imageUrl:'https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=400&h=530&fit=crop&q=80', rating:4.4, reviewCount:64,  sizes:['Free Size'], colors:['Gold','Silver','Black'], category:'women', isNew:true },
  { id:25, name:'Slim Chino Trousers',        brand:'MARKS & SPENCER',price:1999,originalPrice:3999,imageUrl:'https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=400&h=530&fit=crop&q=80', rating:4.2, reviewCount:91,  sizes:['28','30','32','34','36'], colors:['Khaki','Navy','Olive'], category:'men' },
  { id:26, name:'Anarkali Suit Set',          brand:'BIBA',        price:3299, originalPrice:5999, imageUrl:'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=400&h=530&fit=crop&q=80', rating:4.6, reviewCount:189, sizes:['XS','S','M','L','XL'], colors:['Red','Blue','Green'], category:'women', isNew:true },
  { id:27, name:'Running Track Pants',        brand:'ADIDAS',      price:1499, originalPrice:2999, imageUrl:'https://images.unsplash.com/photo-1506629082955-511b1aa562c8?w=400&h=530&fit=crop&q=80', rating:4.3, reviewCount:112, sizes:['S','M','L','XL','XXL'], colors:['Black','Grey','Navy'], category:'men' },
  { id:28, name:'Wicker Bucket Bag',          brand:'ZARA',        price:2299, originalPrice:4499, imageUrl:'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=400&h=530&fit=crop&q=80', rating:4.1, reviewCount:55,  sizes:['Free Size'], colors:['Natural','Black'], category:'women' },
  { id:29, name:'Kids Graphic Sweatshirt',    brand:'GAP',         price:999,  originalPrice:1999, imageUrl:'https://images.unsplash.com/photo-1503944583220-79d8926ad5e2?w=400&h=530&fit=crop&q=80', rating:4.5, reviewCount:83,  sizes:['2-3Y','4-5Y','6-7Y','8-9Y','10-11Y'], colors:['Blue','Red','Green'], category:'kids' },
  { id:30, name:'Satin Slip Evening Dress',   brand:'FOREVER 21',  price:2799, originalPrice:5499, imageUrl:'https://images.unsplash.com/photo-1566174053879-31528523f8ae?w=400&h=530&fit=crop&q=80', rating:4.4, reviewCount:143, sizes:['XS','S','M','L'], colors:['Black','Champagne','Wine'], category:'women', isNew:true },
];

const HEROES = [
  { id:1, tag:'NEW SEASON', title:'Dress to\nImpresse', sub:'Premium womenswear — crafted for the bold.', cta:'Shop Women', link:'/products/women',
    img:'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=700&h=800&fit=crop&q=80',
    grad:'linear-gradient(120deg,#0D0D1F 0%,#1a0a2e 100%)' },
  { id:2, tag:'TRENDING', title:"Men's Edit\n2025", sub:'Redefine your wardrobe with premium picks.', cta:'Shop Men', link:'/products/men',
    img:'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=700&h=800&fit=crop&q=80',
    grad:'linear-gradient(120deg,#070711 0%,#0a0a20 100%)' },
  { id:3, tag:'SALE — UP TO 70% OFF', title:'End of\nSeason Sale', sub:'Top brands, unbeatable prices. Limited time.', cta:'Shop Sale', link:'/products?sale=true',
    img:'https://images.unsplash.com/photo-1607082349566-187342175e2f?w=700&h=800&fit=crop&q=80',
    grad:'linear-gradient(120deg,#120028 0%,#1a0010 100%)' },
];

const CATEGORIES = [
  { name:'Men',        link:'/products/men',                  img:'https://images.unsplash.com/photo-1490578474895-699cd4e2cf59?w=300&h=380&fit=crop&q=80' },
  { name:'Women',      link:'/products/women',                img:'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=300&h=380&fit=crop&q=80' },
  { name:'Kids',       link:'/products/kids',                 img:'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=300&h=380&fit=crop&q=80' },
  { name:'Accessories',link:'/products?category=accessories', img:'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=300&h=380&fit=crop&q=80' },
  { name:'Footwear',   link:'/products?category=footwear',    img:'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=300&h=380&fit=crop&q=80' },
  { name:'Ethnic',     link:'/products?sub=ethnic',           img:'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=300&h=380&fit=crop&q=80' },
];

const BRANDS = ["ZARA","H&M","LEVI'S","NIKE","ADIDAS","PUMA","MANGO","BIBA","FOREVER 21","LACOSTE","CAPRESE","VAN HEUSEN"];

const PERKS = [
  { icon:'🚀', title:'Express Delivery', desc:'Same-day delivery in 20+ cities' },
  { icon:'↩️', title:'30-Day Returns',   desc:'Hassle-free return policy' },
  { icon:'🔒', title:'Secure Payments',  desc:'256-bit encrypted checkout' },
  { icon:'🏆', title:'5000+ Brands',     desc:'Authentic products guaranteed' },
];

function HeartIcon({ filled }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

function ProductCard({ product, isWishlisted, onWishlist, onAddToCart }) {
  const navigate  = useNavigate();
  const discount  = product.originalPrice ? Math.round((1 - product.price / product.originalPrice) * 100) : 0;
  return (
    <div className="product-card" onClick={() => navigate(`/product/${product.id}`)}>
      <div className="product-image-wrap">
        {product.imageUrl
          ? <img src={product.imageUrl} alt={product.name} loading="lazy" />
          : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:72, background:'#F8F5FF' }}>{product.imageEmoji || '👗'}</div>
        }
        {product.isNew && <span className="product-badge-new">NEW</span>}
        {discount > 0 && <span className="product-badge">{discount}% OFF</span>}
        <button className={`wishlist-btn${isWishlisted ? ' wishlisted' : ''}`}
          onClick={e => { e.stopPropagation(); onWishlist(); }}>
          <HeartIcon filled={isWishlisted} />
        </button>
        <div className="card-hover-overlay">
          <button className="quick-add-btn" onClick={e => { e.stopPropagation(); onAddToCart(); }}>
            Add to Bag
          </button>
        </div>
      </div>
      <div className="product-info">
        <p className="product-brand">{product.brand}</p>
        <p className="product-name">{product.name}</p>
        <div className="price-wrap">
          <span className="price-current">₹{product.price.toLocaleString()}</span>
          {product.originalPrice && <span className="price-original">₹{product.originalPrice.toLocaleString()}</span>}
          {discount > 0 && <span className="price-discount">{discount}% off</span>}
        </div>
        <div className="product-rating">
          <span className="star-rating">★ {product.rating}</span>
          <span className="rating-count">({product.reviewCount})</span>
        </div>
      </div>
    </div>
  );
}

export default function Home() {
  const navigate   = useNavigate();
  const dispatch   = useDispatch();
  const { isAuthenticated } = useSelector(s => s.auth);
  const wishlistItems = useSelector(s => s.wishlist.items);
  const [trending, setTrending] = useState(ALL_PRODUCTS.slice(0, 10));
  const [newArrivals, setNewArrivals] = useState(ALL_PRODUCTS.filter(p => p.isNew).slice(0, 8));
  const [featured, setFeatured] = useState(ALL_PRODUCTS.slice(10, 18));
  const sectionRef = useRef(null);

  useEffect(() => {
    api.get('/api/products/trending')
      .then(r => { const d = r.data; if (Array.isArray(d) && d.length > 0) setTrending(d); })
      .catch(() => {});
    api.get('/api/products/new-arrivals')
      .then(r => { const d = r.data; if (Array.isArray(d) && d.length > 0) setNewArrivals(d); })
      .catch(() => {});
    api.get('/api/products/featured')
      .then(r => { const d = r.data; if (Array.isArray(d) && d.length > 0) setFeatured(d); })
      .catch(() => {});
  }, []);

  const isWishlisted = id => wishlistItems.some(i => i.id === id);
  const handleWishlist = product => {
    if (!isAuthenticated) { navigate('/login'); return; }
    if (isWishlisted(product.id)) { dispatch(removeFromWishlist(product.id)); toast.info('Removed from wishlist'); }
    else { dispatch(addToWishlist(product)); toast.success('Added to wishlist!'); }
  };
  const handleAddToCart = product => {
    if (!isAuthenticated) { navigate('/login'); return; }
    dispatch(addToCart({ ...product, quantity:1, selectedSize: product.sizes?.[0] || 'M' }));
    toast.success('Added to bag! 🛍️');
  };

  const heroSettings = {
    dots:true, infinite:true, speed:700, slidesToShow:1, slidesToScroll:1,
    autoplay:true, autoplaySpeed:5000, fade:true, arrows:false,
    appendDots: dots => <div className="hero-dots-wrap"><ul>{dots}</ul></div>,
  };
  const brandSettings = {
    dots:false, infinite:true, speed:500, slidesToShow:6, slidesToScroll:1,
    autoplay:true, autoplaySpeed:2000, arrows:false,
    responsive:[
      { breakpoint:1024, settings:{ slidesToShow:4 }},
      { breakpoint:768,  settings:{ slidesToShow:3 }},
      { breakpoint:480,  settings:{ slidesToShow:2 }},
    ],
  };


  return (
    <div className="home">

      {/* ══ HERO ══ */}
      <section className="hero-section">
        <Slider {...heroSettings}>
          {HEROES.map(h => (
            <div key={h.id}>
              <div className="hero-slide" style={{ background: h.grad }}>
                <div className="hero-content">
                  <span className="hero-tag">{h.tag}</span>
                  <h1 className="hero-title">{h.title.split('\n').map((line,i)=>(
                    <span key={i}>{i===1 ? <span className="text-gradient">{line}</span> : line}<br/></span>
                  ))}</h1>
                  <p className="hero-sub">{h.sub}</p>
                  <Link to={h.link} className="btn btn-primary hero-cta">{h.cta} →</Link>
                  <div className="hero-stats">
                    <div className="hero-stat"><span>5K+</span><p>Brands</p></div>
                    <div className="hero-stat-divider"/>
                    <div className="hero-stat"><span>2M+</span><p>Products</p></div>
                    <div className="hero-stat-divider"/>
                    <div className="hero-stat"><span>70%</span><p>Off</p></div>
                  </div>
                </div>
                <div className="hero-image-col">
                  <div className="hero-img-wrap">
                    <img src={h.img} alt={h.title} className="hero-img" />
                    <div className="hero-img-glow"/>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </section>

      {/* ══ PERKS ══ */}
      <section className="perks-bar">
        {PERKS.map(p => (
          <div key={p.title} className="perk-item">
            <span className="perk-icon">{p.icon}</span>
            <div>
              <p className="perk-title">{p.title}</p>
              <p className="perk-desc">{p.desc}</p>
            </div>
          </div>
        ))}
      </section>

      {/* ══ CATEGORIES ══ */}
      <section className="home-section" ref={sectionRef}>
        <div className="home-container">
          <div className="section-header-row">
            <div>
              <span className="section-label">EXPLORE</span>
              <h2 className="section-title">Shop by <span className="text-gradient">Category</span></h2>
            </div>
          </div>
          <div className="categories-grid">
            {CATEGORIES.map(c => (
              <Link to={c.link} key={c.name} className="cat-card">
                <div className="cat-img-wrap">
                  <img src={c.img} alt={c.name} loading="lazy" />
                  <div className="cat-overlay" />
                </div>
                <div className="cat-info">
                  <p className="cat-name">{c.name}</p>
                  <span className="cat-cta">Shop →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ══ TRENDING ══ */}
      <section className="home-section home-section--dark">
        <div className="home-container">
          <div className="section-header-row">
            <div>
              <span className="section-label">HOT RIGHT NOW</span>
              <h2 className="section-title">Trending <span className="text-gradient">Now</span></h2>
            </div>
            <Link to="/products" className="see-all-link">View All →</Link>
          </div>
          <div className="products-grid">
            {trending.map((p, i) => (
              <div key={p.id} className="animate-fadeInUp" style={{ animationDelay: `${i * 0.05}s` }}>
                <ProductCard product={p} isWishlisted={isWishlisted(p.id)}
                  onWishlist={() => handleWishlist(p)} onAddToCart={() => handleAddToCart(p)} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ PROMO SPLIT ══ */}
      <section className="promo-split">
        <Link to="/products/women" className="promo-card promo-left">
          <img src="https://images.unsplash.com/photo-1483985988355-763728e1935b?w=700&h=500&fit=crop&q=80" alt="Women" />
          <div className="promo-overlay" />
          <div className="promo-text">
            <span className="section-label">WOMEN'S EDIT</span>
            <h3>Fashion Forward</h3>
            <p>New collection every week</p>
            <span className="promo-cta">Shop Now →</span>
          </div>
        </Link>
        <div className="promo-right">
          <Link to="/products/men" className="promo-card promo-sm">
            <img src="https://images.unsplash.com/photo-1490578474895-699cd4e2cf59?w=500&h=300&fit=crop&q=80" alt="Men" />
            <div className="promo-overlay" />
            <div className="promo-text">
              <span className="section-label">MEN'S</span>
              <h3>Style Essentials</h3>
              <span className="promo-cta">Explore →</span>
            </div>
          </Link>
          <Link to="/products?sale=true" className="promo-card promo-sm">
            <img src="https://images.unsplash.com/photo-1607082349566-187342175e2f?w=500&h=300&fit=crop&q=80" alt="Sale" />
            <div className="promo-overlay promo-overlay--sale" />
            <div className="promo-text">
              <span className="section-label">LIMITED TIME</span>
              <h3>Up to 70% OFF</h3>
              <span className="promo-cta">Grab Deal →</span>
            </div>
          </Link>
        </div>
      </section>

      {/* ══ NEW ARRIVALS ══ */}
      <section className="home-section">
        <div className="home-container">
          <div className="section-header-row">
            <div>
              <span className="section-label">JUST DROPPED</span>
              <h2 className="section-title">New <span className="text-gradient">Arrivals</span></h2>
            </div>
            <Link to="/products?sort=newest" className="see-all-link">View All →</Link>
          </div>
          <div className="products-grid">
            {newArrivals.map((p, i) => (
              <div key={p.id} className="animate-fadeInUp" style={{ animationDelay: `${i * 0.05}s` }}>
                <ProductCard product={p} isWishlisted={isWishlisted(p.id)}
                  onWishlist={() => handleWishlist(p)} onAddToCart={() => handleAddToCart(p)} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ BRANDS ══ */}
      <section className="home-section home-section--dark brands-section">
        <div className="home-container">
          <div className="section-header-row">
            <div>
              <span className="section-label">PARTNERSHIPS</span>
              <h2 className="section-title">Top <span className="text-gradient">Brands</span></h2>
            </div>
          </div>
          <Slider {...brandSettings} className="brands-slider">
            {BRANDS.map(b => (
              <div key={b} className="brand-slide">
                <Link to={`/products?brand=${encodeURIComponent(b)}`} className="brand-pill">
                  {b}
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* ══ FEATURED ══ */}
      <section className="home-section">
        <div className="home-container">
          <div className="section-header-row">
            <div>
              <span className="section-label">CURATED FOR YOU</span>
              <h2 className="section-title">Featured <span className="text-gradient">Picks</span></h2>
            </div>
            <Link to="/products" className="see-all-link">View All →</Link>
          </div>
          <div className="products-grid">
            {featured.map((p, i) => (
              <div key={p.id} className="animate-fadeInUp" style={{ animationDelay: `${i * 0.05}s` }}>
                <ProductCard product={p} isWishlisted={isWishlisted(p.id)}
                  onWishlist={() => handleWishlist(p)} onAddToCart={() => handleAddToCart(p)} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ NEWSLETTER ══ */}
      <section className="newsletter-section">
        <div className="newsletter-inner">
          <div className="newsletter-glow" />
          <span className="section-label">EXCLUSIVE ACCESS</span>
          <h2>Stay <span className="text-gradient">Ahead</span> of Fashion</h2>
          <p>Subscribe for early access to drops, exclusive offers, and style guides.</p>
          <form className="newsletter-form" onSubmit={e => { e.preventDefault(); toast.success('You\'re on the list! 🎉'); }}>
            <input type="email" placeholder="Enter your email address" required className="newsletter-input" />
            <button type="submit" className="btn btn-primary">Subscribe</button>
          </form>
          <p className="newsletter-note">Join 2M+ members. No spam, ever.</p>
        </div>
      </section>
    </div>
  );
}
